import { SxProps, TextFieldProps } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers-pro';
import React from 'react';

import { LegacyMuiTextField } from '~/legacy-components/LegacyForms/components/LegacyMuiTextField';
import { mergeSxProps } from '~/utils/helpers/sxProps';

import { useSxStyles } from './useStyles';

export type DatePickerPropsFragment<TDate> = Omit<
  DatePickerProps<TDate>,
  'renderInput'
>;

type Props<TDate> = DatePickerPropsFragment<TDate> & {
  error?: boolean;
  id?: string;
  sx?: SxProps<Theme>;
};

export const LegacyDateInput = <TDate,>(props: Props<TDate>) => {
  const { error, id, sx, ...rest } = props;
  const sxStyles = useSxStyles();

  const pickerProps: DatePickerPropsFragment<TDate> = {
    ...rest,
  };

  return (
    <DatePicker
      {...pickerProps}
      slots={{
        textField: (params: TextFieldProps) => (
          <LegacyMuiTextField
            {...params}
            error={!!error || params.error}
            id={id}
            sx={mergeSxProps(sxStyles.dateInput, params.sx, sx)}
          />
        ),
      }}
    />
  );
};
